import titles from "@/store/lang/titles.json";
import { mapGetters, mapActions } from "vuex";
import Success from "../success/Success.vue";
import Tooltip from "../tooltip/tooltip.vue";
import InvisibleRecaptcha from "vue-invisible-recaptcha";

export default {
  name: "Delivery",
  components: {
    Success,
    Tooltip,
    InvisibleRecaptcha,
  },
  data() {
    const today = new Date();
    let businessDays = 5;
    let dayCount = 0;
    const fiveBusinessDaysLater = new Date(today);
    
    while (dayCount < businessDays) {
      fiveBusinessDaysLater.setDate(fiveBusinessDaysLater.getDate() + 1);
      // Increment dayCount only if it's a weekday
      if (fiveBusinessDaysLater.getDay() !== 5 && fiveBusinessDaysLater.getDay() !== 6) {
        dayCount++;
      }
    }

    let twoWeeksLater = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 14);
    //console.log("Initial maxDate:", twoWeeksLater);

    // Adjust twoWeeksLater if it falls on a weekend
    if (twoWeeksLater.getDay() === 5) { // if it's Saturday
      twoWeeksLater.setDate(twoWeeksLater.getDate() + 2);
    } else if (twoWeeksLater.getDay() === 6) { // if it's Sunday
      twoWeeksLater.setDate(twoWeeksLater.getDate() + 1);
    }

    // Extend by two more days
    twoWeeksLater.setDate(twoWeeksLater.getDate() + 2);

    //console.log("Adjusted maxDate after adding extra days for weekends:", twoWeeksLater);

    return {
      minDate: fiveBusinessDaysLater.toISOString().substr(0, 10), // Updated to 5 business days later, excluding weekends
      maxDate: twoWeeksLater.toISOString().substr(0, 10),  // two weeks from today adjusted for weekends
      logistics_approve: false,
      DeliveryTitles: titles.DeliveryTitles,
      isActiveFrontDoor: false,
      isActiveRearDoor: false,
      confirmationOfEnoughSpace: false,
      confirmationOfContainerStatus: false,
      confirmationDeliverySurface: false,
      panelOpen: 0,
      doorDirectionTick: false,
      doorDirectionValid: false,
      deliverySpaceTick: false,
      deliverySpaceValid: false,
      containerStatusTick: false,
      nonAcceptableDatesTick: false,
      otherInfoTick: false,
      deliveryContactTick: false,
      deliverySurface: false,
      deliverySurfaceValid: false,
      rulesTitles: titles.rulesTitle.delivery,
      containerStatusValid: false,
      deliveryContactValid: false,
      contactDetailsValid: false, // Add this line to define contactDetailsValid
      rules: {
        deliverySpaceRules: [
          (v) => !!v || titles.rulesTitle.delivery.fieldIsRequired,
        ],
        nameRules: [
          (v) => !!v || titles.rulesTitle.creditApplication.fieldIsRequired,
        ],
        phoneNumberRules: [
          (v) => !!v || titles.rulesTitle.creditApplication.phoneNumber,
          function(v) {
            if (v) {
              let value = v.replace(/\D/g, "");
              return (
                (!isNaN(parseFloat(value)) && value.length == 10) ||
                titles.rulesTitle.creditApplication.validPhoneNum
              );
            }
            return titles.rulesTitle.creditApplication.validPhoneNum;
          },
        ],
      },
      requestForm: {
        event_type: "delivery_instruction_request",
        order_number: "",
        market_code: "",
        order_header_id: "",
        contact_name: "",
        contact_phone: "",
        door_direction: "",
        space_confirmation: "",
        container_condition_confirmation: "",
        surface_type: "",
        non_acceptable_dates: [],
        additional_info: "",
        CountryCode: "",
      },
      isSubmitSuccessful: false,
      activeStep: 1,
      animation: "animate-in",
      orderDetails: null,
      loading: false,
      orderDetailsTick: false,
      isSubmitting: false,
      logisticsPhone: {
        US: "(800) 768-6080",
        CA: "(800) 925-2515",
      },
    };
  },
  computed: {
    ...mapGetters(["getCountryCode"]),
    progress() {
      var pg = ((this.activeStep - 1) / 7) * 100;

      return pg;
    },
  },
  methods: {
    ...mapActions(["addFormRequest", "getFormRequest"]),
    isDateAllowed(date) {
      const day = new Date(date).getDay();
      //console.log('Checking date:', date, 'Day:', day);
      // Return false if the day is Saturday (5) or Sunday (6)
      return day !== 5 && day !== 6;
    },
    validateDoorDirectionsFields() {
      if (this.isActiveFrontDoor || this.isActiveRearDoor) {
        this.doorDirectionValid = true;
        this.nextStep();
      } else {
        this.doorDirectionValid = false;
        this.notValid();
      }
      this.doorDirectionTick = this.doorDirectionValid;
    },
    validateDeliverySpaceFields() {
      this.deliverySpaceValid = this.$refs.deliverySpaceForm.validate();
      this.deliverySpaceTick = this.deliverySpaceValid;
      return this.deliverySpaceValid;
    },
    validateContainerStatusFields() {
      this.containerStatusValid = this.$refs.containerStatusForm.validate();
      this.containerStatusTick = this.containerStatusValid;
      return this.containerStatusValid;
    },
    validateDeliverySurfaceFields() {
      this.deliverySurfaceValid = this.$refs.deliverySurfaceForm.validate();
      this.deliverySurfaceTick = this.deliverySurfaceValid;
      return this.deliverySurfaceValid;
    },
    validatedeliveryContactFields() {
      this.deliveryContactValid = this.$refs.deliveryContactForm.validate();
      this.deliveryContactTick = this.deliveryContactValid;
      return this.deliveryContactValid;
    },
    getPriorPanel(event, idx) {
      event ? event.preventDefault() : null;
      switch (idx) {
        case 2:
          this.priorStep();
          break;
        case 3:
          this.priorStep();
          break;
        case 4:
          this.priorStep();
          break;
        case 5:
          this.priorStep();
          break;
        case 6:
          this.priorStep();
          break;
        case 7:
          this.priorStep();
          break;
        case 8:
          this.priorStep();
          break;
      }
    },
    getNextPanel(event, idx) {
      switch (idx) {
        case 1:
          this.orderDetailsTick = true;
          this.nextStep();
          break;
        case 2:
          this.validateDoorDirectionsFields();
          break;
        case 3:
          !this.validateDeliverySpaceFields()
            ? this.notValid()
            : this.nextStep();
          break;
        case 4:
          !this.validateContainerStatusFields()
            ? this.notValid()
            : this.nextStep();
          break;
        case 5:
          !this.validateDeliverySurfaceFields()
            ? this.notValid()
            : this.nextStep();
          break;
        case 6:
          this.nonAcceptableDatesTick = true;
          this.nextStep();
          break;
        case 7:
          this.otherInfoTick = true;
          this.nextStep();
          break;
        case 8:
          if (!this.validatedeliveryContactFields()) {
            this.notValid();
          } else {
            this.submit();
          }
          break;
      }
    },
    makeSelection(option) {
      switch (option) {
        case "Doors Toward Cab (off last)":
          this.isActiveFrontDoor = true;
          this.isActiveRearDoor = false;
          this.requestForm.door_direction = "Doors Toward Cab (off last)";
          break;
        case "Doors Toward Rear (off first)":
          this.isActiveFrontDoor = false;
          this.isActiveRearDoor = true;
          this.requestForm.door_direction = "Doors Toward Rear (off first)";
          break;
      }
    },
    submit() {
      this.panelOpen = null;
      this.requestForm.CountryCode = this.getCountryCode;
      this.isSubmitting = true;
      this.addFormRequest({
        data: this.requestForm,
        event_type: this.requestForm.event_type,
      })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.ResponseMetadata &&
            response.data.ResponseMetadata.HTTPStatusCode == 200
          )
            this.isSubmitSuccessful = true;
          this.isSubmitting = false;
        })
        .catch((err) => {
          console.log(err);
          this.isSubmitting = false;
        });
    },
    getRequestForm() {
      this.requestForm = {
        event_type: "delivery_instruction_request",
        order_number: this.orderDetails.Order_Number,
        order_header_id: this.orderDetails.Order_Header_Id,
        market_code: this.orderDetails.Market_Code,
        contact_name: "",
        contact_phone: "",
        door_direction: "",
        space_confirmation: "",
        container_condition_confirmation: "",
        surface_type: "",
        non_acceptable_dates: [],
        additional_info: "",
        CountryCode: this.getCountryCode,
      };
      this.isActiveFrontDoor = false;
      this.isActiveRearDoor = false;
      this.isSubmitSuccessful = false;
      this.activeStep = 1;
      this.orderDetailsTick = false;
      this.doorDirectionTick = false;
      this.deliverySpaceTick = false;
      this.containerStatusTick = false;
      this.deliverySurfaceTick = false;
      this.nonAcceptableDatesTick = false;
      this.otherInfoTick = false;
      this.deliveryContactTick = false;
    },
    priorStep() {
      this.animation = "animate-out";
      setTimeout(() => {
        this.animation = "animate-in";
        this.activeStep -= 1;
      }, 600);
    },
    nextStep() {
      this.animation = "animate-out";
      setTimeout(() => {
        this.animation = "animate-in";
        this.activeStep += 1;
      }, 600);
    },
    notValid() {
      this.animation = "animate-wrong";
      setTimeout(() => {
        this.animation = "";
      }, 400);
    },
    getStepperContent(step) {
      this.activeStep = step;
      switch (step) {
        case 1:
          this.orderDetailsTick = false;
          break;
        case 2:
          this.doorDirectionTick = false;
          break;
        case 3:
          this.deliverySpaceTick = false;
          break;
        case 4:
          this.containerStatusTick = false;
          break;
        case 5:
          this.deliverySurfaceTick = false;
          break;
        case 6:
          this.nonAcceptableDatesTick = false;
          break;
        case 7:
          this.otherInfoTick = false;
          break;
        case 8:
          this.deliveryContactTick = false;
          break;
      }
    },
    isAllValid() {
      return (
        !(
          this.orderDetailsTick &&
          this.doorDirectionTick &&
          this.deliverySpaceTick &&
          this.containerStatusTick &&
          this.deliverySurfaceTick &&
          this.nonAcceptableDatesTick &&
          this.otherInfoTick &&
          this.requestForm.contact_name &&
          this.requestForm.contact_phone.length == 14
        ) || this.isSubmitting
      );
    },
    submitted(response) {
      /*resposne will have the reCAPTCHA token.
      If token is null or empty do nothing.*/
      if (!response) return;
      this.getNextPanel(null, this.activeStep);
    },
    /*Get the order details using
    the encrypted query parameter "o"*/
    getOrderDeatils() {
      this.loading = true;
      this.getFormRequest({
        id: this.$route.query.o,
        event_type: this.requestForm.event_type,
      })
        .then((response) => {
          if (
            response.data &&
            response.data.statusCode == 200 &&
            response.data.body
          ) {
            const ORDER = response.data.body;
            const IDX = ORDER["OrderLineItems"].findIndex(
              (p) => p.SKU == "HAULING"
            );
            this.orderDetails = {
              Order_Number: ORDER.Order_Number,
              Order_Header_Id: ORDER.order_header_id,
              Quantity: ORDER["OrderLineItems"][IDX].Quantity,
              Market_Code: ORDER.Market_Code,
              ShippingAddress: ORDER.ShippingAddress,
            };
            this.requestForm.order_number = this.orderDetails.Order_Number;
            this.requestForm.order_header_id = this.orderDetails.Order_Header_Id;
            this.requestForm.market_code = this.orderDetails.Market_Code;

            this.logistics_approve = response.data.body.LOGISTICS_APPROVED;
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
  },
  mounted() {
    if (this.$route.query.o) this.getOrderDeatils();
  },
};
